import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP6ChurnedNew202604: FaireAdPerformancePeriodEntity = {
  token: "perf_p6_churned_new_202604",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-04-01",
  endDate: "2026-04-30",
  impressions: 63715,
  clicks: 1309,
  adsSpendDollars: 5396,
  budgetDollars: 5400,
  salesDollars: 11252,
  bestEstimateRoas: 2.09,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 1,
  newCustomersAcquired: 25,
  dataAvailableAtDate: "2026-05-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
